var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowedToShow)?_c('div',{staticClass:"project-customer-table-cell"},[_c('v-avatar',[(_vm.customer.logoURL)?_c('img',{staticClass:"avatar",attrs:{"src":(_vm.customer.logoURL)}}):_c('v-icon',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))])],1),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.customer.name)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }